import { gql } from "@apollo/client";
import {
  ConnectAccount,
  ConnectBalance,
  ConnectPayoutList,
  ConnectTransactionList,
  ConnectOnboardingResult,
  OnlinePaymentSummary,
} from "./models";

// Response types
export type GetConnectAccountResponse = {
  getConnectAccount: ConnectAccount | null;
};

export type GetConnectBalanceResponse = {
  getConnectBalance: ConnectBalance | null;
};

export type GetConnectPayoutsResponse = {
  getConnectPayouts: ConnectPayoutList;
};

export type GetConnectTransactionsResponse = {
  getConnectTransactions: ConnectTransactionList;
};

export type GetOnlinePaymentSummaryResponse = {
  getOnlinePaymentSummary: OnlinePaymentSummary;
};

export type CreateConnectAccountResponse = {
  createConnectAccount: ConnectOnboardingResult;
};

export type CreateConnectOnboardingLinkResponse = {
  createConnectOnboardingLink: ConnectOnboardingResult;
};

export type CreateConnectLoginLinkResponse = {
  createConnectLoginLink: ConnectOnboardingResult;
};

export type UnlinkConnectAccountResponse = {
  unlinkConnectAccount: boolean;
};

export type UpdateConnectAccountResponse = {
  updateConnectAccount: ConnectOnboardingResult;
};

// Queries
export const GET_CONNECT_ACCOUNT = gql`
  query GetConnectAccount {
    getConnectAccount {
      id
      status
      charges_enabled
      payouts_enabled
      details_submitted
      email
      business_profile_name
      commission_rate
    }
  }
`;

export const GET_CONNECT_BALANCE = gql`
  query GetConnectBalance {
    getConnectBalance {
      available
      pending
      currency
    }
  }
`;

export const GET_CONNECT_PAYOUTS = gql`
  query GetConnectPayouts($limit: Int, $starting_after: String) {
    getConnectPayouts(limit: $limit, starting_after: $starting_after) {
      data {
        id
        amount
        currency
        status
        arrival_date
        created
        description
        method
      }
      has_more
    }
  }
`;

export const GET_CONNECT_TRANSACTIONS = gql`
  query GetConnectTransactions($limit: Int, $starting_after: String) {
    getConnectTransactions(limit: $limit, starting_after: $starting_after) {
      data {
        id
        amount
        fee
        net
        currency
        type
        description
        created
        status
      }
      has_more
    }
  }
`;

export const GET_ONLINE_PAYMENT_SUMMARY = gql`
  query GetOnlinePaymentSummary(
    $startDate: String!
    $endDate: String!
    $branch_id: Int
  ) {
    getOnlinePaymentSummary(
      startDate: $startDate
      endDate: $endDate
      branch_id: $branch_id
    ) {
      totalRevenue
      totalFees
      totalNet
      totalOrders
      dailyBreakdown {
        date
        count
        total
        fees
        net
      }
    }
  }
`;

// Mutations
export const CREATE_CONNECT_ACCOUNT = gql`
  mutation CreateConnectAccount {
    createConnectAccount {
      url
    }
  }
`;

export const CREATE_CONNECT_ONBOARDING_LINK = gql`
  mutation CreateConnectOnboardingLink {
    createConnectOnboardingLink {
      url
    }
  }
`;

export const CREATE_CONNECT_LOGIN_LINK = gql`
  mutation CreateConnectLoginLink {
    createConnectLoginLink {
      url
    }
  }
`;

export const UNLINK_CONNECT_ACCOUNT = gql`
  mutation UnlinkConnectAccount {
    unlinkConnectAccount
  }
`;

export const UPDATE_CONNECT_ACCOUNT = gql`
  mutation UpdateConnectAccount {
    updateConnectAccount {
      url
    }
  }
`;
